import React from 'react';
import { CheckCircle2, MailCheck, PhoneCall, Calendar } from 'lucide-react';

export default function SuccessScreen({ data }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="rounded-2xl overflow-hidden bg-white shadow-[0_24px_60px_-20px_rgba(19,15,40,0.25)] border border-[#ece8df] fade-up"
    >
      <div className="px-6 py-8 text-center" style={{ backgroundColor: '#130F28', color: '#FAFAF9' }}>
        <div className="text-5xl mb-2" aria-hidden="true">🎉</div>
        <h3 className="font-serif text-3xl">You're all set!</h3>
        <p className="text-white/70 mt-2 text-sm">
          Check your inbox{data?.email ? <> at <span className="font-semibold text-white">{data.email}</span></> : ''} for your confirmation. Here's what happens next:
        </p>
      </div>
      <div className="p-6 space-y-4">
        <TimelineItem
          badge={<CheckCircle2 size={18} aria-hidden="true" />}
          color="#10C98F"
          title="Right now: Setup complete"
          body="Intake received. Your account has been created and our team has been notified."
        />
        <TimelineItem
          badge={<MailCheck size={18} aria-hidden="true" />}
          color="#6B4BEF"
          title="Within 24 hours: Welcome email from your team"
          body="You'll receive an email within 24 hours walking you through the next steps. During your first 7 days, campaign emails come to your inbox, not your customers."
        />
        <TimelineItem
          badge={<span className="text-xs font-bold">48h</span>}
          color="#6B4BEF"
          title="Within 48 hours: Your first campaign email arrives"
          body="Your Nurture & Referral Campaign email is built by AI agents checking each other, and delivered to your inbox. Nothing goes to your customer list during Try it Out."
        />
        <TimelineItem
          badge={<PhoneCall size={18} aria-hidden="true" />}
          color="#6B4BEF"
          title="Day 5: Check-in call"
          body="A 20-minute call to review how Try it Out is going and answer any questions."
        />
        <TimelineItem
          badge={<Calendar size={18} aria-hidden="true" />}
          color="#10C98F"
          title="Day 7: Try it Out wraps"
          body="You've seen exactly what your customers will see. Your Year 1 continues free. After year one, pricing is expected to start around $299/month. Cancel anytime."
        />
      </div>
    </div>
  );
}

function TimelineItem({ badge, color, title, body }) {
  return (
    <div className="flex gap-3">
      <span
        aria-hidden="true"
        className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-white"
        style={{ backgroundColor: color }}
      >
        {badge}
      </span>
      <div>
        <p className="font-semibold text-sm" style={{ color: '#130F28' }}>{title}</p>
        <p className="text-sm mt-0.5" style={{ color: '#3b3656' }}>{body}</p>
      </div>
    </div>
  );
}
